import $ from "cash-dom"

function modal(element) {
  const $element = $(element)
  if (!$element.length) return

  const animate = $element.hasClass("fade") ? "fade" : ""

  function escape_key_callback(e) {
    e.which === 27 && hide()
  }

  function hide() {
    const $backdrop = $(".modal-backdrop")
    if (!$backdrop.length) return

    document.removeEventListener("close_modal", hide)
    $(window).off("keyup.dismiss.modal", escape_key_callback)
    $element.trigger("hide").removeClass("in")
    setTimeout(() => {
      $backdrop.remove()
      $element.hide()
    }, animate ? 400 : 0)
    return false
  }

  document.addEventListener("close_modal", hide)

  $(`<div class="modal-backdrop in ${animate}" />`)
    .appendTo(document.body)
    .on("click", hide)

  $(window).on("keyup.dismiss.modal", escape_key_callback)
  $element
    .trigger("show")
    .show()
    .addClass("in")
    .find("[data-dismiss='modal']").on("click.dismiss.modal", hide)

  $element[0].focus()

  return hide
}

export default modal
